import React from 'react';
import './speakerCard.scss';

export default class SpeakerCard extends React.Component {

    handleSpeakerClick = (event) => {
        this.props.onOpenSpeaker(event.currentTarget.dataset["id"]);
    };


    render() {
        let splitedName = this.props.fullName.split(" ");
        /*const initials = `${data.fullName.split(' ')}*/
        /*
                const name = data.fullName;
                const title = (data.title || data.job) + ', ' + data.organization;
                const avatarStyle = this.getAvatarStyle(data);
                const biography = {__html: data.biography};*/

        const speakerInfoClassName = this.props.noDetail ? ' no-detail' : '';

        return (
            <div className="col-lg-3 col-md-6 col-sm-12 speaker-item">
                <div className={"row justify-content-center speaker-info" + speakerInfoClassName} data-aos="fade-up" data-aos-duration="1000" data-aos-anchor-placement="top-bottom" data-id={this.props.fullName}
                     onClick={this.handleSpeakerClick}>
                    <a>
                        {!!this.props.photo ? <img src={this.props.photo} className="speaker-detail-avatar"/> :
                            <div className="speaker-avatar-alt">{`${splitedName[0].charAt(0)}${splitedName[splitedName.length - 1].charAt(0)}`}</div>}
                        <div className="speaker-name-general">
                            {this.props.fullName}
                        </div>
                        <div className="speaker-status-general">
                            {this.props.title}
                        </div>
                        <div className="speaker-status-general">
                            {this.props.organization}
                        </div>
                    </a>
                </div>
            </div>

        );
    }

    getAvatarStyle(data) {
        if (!data.photo) return null;
        const {avatarBaseUrl} = this.props;

        const baseUrl = avatarBaseUrl.startsWith('http') ? avatarBaseUrl : (PubHub.instance ? PubHub.instance.location : '') + avatarBaseUrl;
        const bg = data.photo.startsWith('http') ? `url("${data.photo}")` : `url("${baseUrl}${data.photo}")`;
        return bg;
    }
}
